import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "select-site-container"
}
const _hoisted_2 = { class: "recherche-container" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "first-container" }
const _hoisted_5 = { class: "select-all-container" }
const _hoisted_6 = { class: "subtitle" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoaderComponent = _resolveComponent("LoaderComponent")!
  const _component_SearchBar = _resolveComponent("SearchBar")!
  const _component_BorderedIconButton = _resolveComponent("BorderedIconButton")!
  const _component_ReglePastille = _resolveComponent("ReglePastille")!
  const _component_ButtonBlue = _resolveComponent("ButtonBlue")!
  const _component_SitesList = _resolveComponent("SitesList")!
  const _component_WaitingModal = _resolveComponent("WaitingModal")!

  return (_ctx.isAcquiringToken)
    ? (_openBlock(), _createBlock(_component_LoaderComponent, { key: 0 }))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.title), 1),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_SearchBar, {
              unpaged: _ctx.isMultiSite,
              "inclure-termines": _ctx.inclureTermines,
              class: "search-bar",
              onFilterChange: _ctx.filterChange
            }, null, 8, ["unpaged", "inclure-termines", "onFilterChange"]),
            (_ctx.exportContact)
              ? (_openBlock(), _createBlock(_component_BorderedIconButton, {
                  key: 0,
                  imgUrl: _ctx.iconeXls,
                  title: _ctx.$t('list.exportContacts'),
                  class: "export-button",
                  onClick: _ctx.exportXlsContact
                }, null, 8, ["imgUrl", "title", "onClick"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('siteSelection.title.site')), 1),
          (_ctx.regleCle)
            ? (_openBlock(), _createBlock(_component_ReglePastille, {
                key: 0,
                cle: _ctx.regleCle
              }, null, 8, ["cle"]))
            : _createCommentVNode("", true),
          (_ctx.isMultiSite)
            ? (_openBlock(), _createBlock(_component_ButtonBlue, {
                key: 1,
                disabled: _ctx.selectedSites?.length === _ctx.sites.length,
                "on-click": _ctx.selectionnerTout,
                text: _ctx.$t('siteSelection.selectionner.tout'),
                class: "button-selection btn"
              }, null, 8, ["disabled", "on-click", "text"]))
            : _createCommentVNode("", true),
          (_ctx.isMultiSite)
            ? (_openBlock(), _createBlock(_component_ButtonBlue, {
                key: 2,
                disabled: _ctx.selectedSites?.length === 0,
                "on-click": _ctx.deselectionnerTout,
                text: _ctx.$t('siteSelection.deselectionner.tout'),
                class: "button-selection btn"
              }, null, 8, ["disabled", "on-click", "text"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", {
          ref: "siteList",
          class: "list-container",
          onScroll: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleScroll && _ctx.handleScroll(...args)))
        }, [
          _createVNode(_component_SitesList, {
            "is-loading": _ctx.isLoading,
            "is-multi-site": _ctx.isMultiSite,
            "selected-sites": _ctx.selectedSites,
            selectedSite: _ctx.selectedSite,
            sites: _ctx.sites,
            "sites-disabled": _ctx.sitesDisabled,
            class: "list",
            onAdd: _ctx.add,
            onPick: _ctx.pick
          }, null, 8, ["is-loading", "is-multi-site", "selected-sites", "selectedSite", "sites", "sites-disabled", "onAdd", "onPick"])
        ], 544),
        (_ctx.isExportXlsLoading)
          ? (_openBlock(), _createBlock(_component_WaitingModal, { key: 0 }))
          : _createCommentVNode("", true)
      ]))
}